<template>
  <div
    v-if="shouldRenderConfig"
    v-show="!getMatrixComplete"
    :class="getClassName"
  >
    <div
      v-for="code in getBundleProductPartCodes"
      :key="code"
      :class="getClassName + 'Item'"
    >
      <appProductPartsNamesBundle
        :ppcode="code"
        :propsData="getBundlePPData(code)"
      >
      </appProductPartsNamesBundle>
      <appPageOptionContainer v-if="isOpen(code)" :ppcode="code">
      </appPageOptionContainer>
      <appPageOptionAllAttributesContainer v-if="isOpen(code)" :ppcode="code">
      </appPageOptionAllAttributesContainer>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { useBundleStore } from "@/stores/modules/bundle";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getActiveProductPageOptions"]),
    ...mapState(useConfigStore, ["getMatrixComplete"]),
    ...mapState(useBundleStore, [
      "getBundlePPData",
      "getBundleProductPartCodes"
    ])
  },

  methods: {
    getProductPageOptionValues: function (pageOption) {
      return this.getActiveProductPageOptions[pageOption].values;
    },
    isOpen: function (ppcode) {
      return this.getBundlePPData(ppcode).isOpen;
    }
  }
};
</script>
